import { Component } from '@angular/core';
import { RouterLink, RouterOutlet, RouterLinkActive } from '@angular/router';

@Component({
  selector: 'app-raw-metal-entry',
  standalone: true,
  imports: [RouterLink, RouterOutlet, RouterLinkActive],
  templateUrl: './raw-metal-entry.component.html',
  styleUrl: './raw-metal-entry.component.css'
})
export class RawMetalEntryComponent {

}
